/* Copyright (C) 2018 TeselaGen Biotechnology, Inc. */
import React, { useEffect } from "react";
import { Prompt } from "react-router-dom";
export var defaultMessagge = "Are you sure you want to leave? There are unsaved changes.";

var warnBeforeLeave = function warnBeforeLeave(e) {
  // if we are in a cypress test run then we don't want to block navigation
  if (window.Cypress) {
    return null;
  } // Maintains older browser compatibility. In newer versions a generic string is returned


  (e || window.event).returnValue = defaultMessagge; //Gecko + IE

  return defaultMessagge; //Webkit, Safari, Chrome
};

export function PromptUnsavedChanges(_ref) {
  var _ref$message = _ref.message,
      message = _ref$message === void 0 ? defaultMessagge : _ref$message,
      _ref$when = _ref.when,
      when = _ref$when === void 0 ? false : _ref$when;
  useEffect(function () {
    if (when) {
      window.addEventListener("beforeunload", warnBeforeLeave);
    }

    return function () {
      return window.removeEventListener("beforeunload", warnBeforeLeave);
    };
  });

  if (window.Cypress) {
    return null;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Prompt, {
    when: when,
    message: message
  }));
}
export default PromptUnsavedChanges;